import { HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';

// Map to store cached responses
const cache = new Map<string, HttpResponse<any>>();

/**
 * HTTP interceptor function that caches GET requests
 * for improved performance and SEO
 */
export function cacheInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // Only cache GET requests
  if (req.method !== 'GET') {
    return next(req);
  }

  // For API calls that shouldn't be cached
  if (req.headers.get('x-no-cache')) {
    return next(req);
  }

  // Generate cache key from URL
  const cachedResponse = cache.get(req.url);

  // Return cached response if available
  if (cachedResponse) {
    return of(cachedResponse.clone());
  }

  // Otherwise, forward request and cache response
  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        cache.set(req.url, event.clone());
      }
    })
  );
}
